import {format} from "date-fns";

export const formatDate = (date, fallback = "-") => {
    if (!date) return fallback;
    try {
        return format(new Date(date), "dd-MM-yyyy");
    } catch {
        return fallback;
    }
};

export const formatDteTime = (date) => {
    return format(date, 'dd-MM-yyyy \'at\' h:mm a');
}